document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll<HTMLButtonElement>(
    '[data-top-event-tab-button]'
  );
  const tabContainer = document.querySelector<HTMLElement>(
    '[data-top-event-tab-container]'
  );
  const tabIds: (string | null)[] = [];

  if (tabButtons.length === 0) return;

  const renderTab = (tabName: string | null) => {
    if (!tabContainer || !tabName) return;

    tabContainer.innerHTML = '';
    const template = document.getElementById(
      `${tabName}-template`
    ) as HTMLTemplateElement;

    if (!template) return;

    const clone = template.content.cloneNode(true);
    tabContainer.appendChild(clone);
  };

  tabButtons.forEach((button) => {
    tabIds.push(button.getAttribute('data-id'));

    button.addEventListener('click', () => {
      const tabName = button.dataset.id as string;
      tabButtons.forEach((button) => {
        button.dataset.active = 'false';
        button.disabled = false;
      });
      button.dataset.active = 'true';
      button.disabled = true;

      renderTab(tabName);
    });
  });

  tabButtons[0].dataset.active = 'true';
  tabButtons[0].disabled = true;
  renderTab(tabIds[0]);
});
